import { NetworkBadgeProps } from '@bitte-ai/types';
import { networkFallbackIcons } from '../../../lib/network-constants';

const NetworkBadge: React.FC<NetworkBadgeProps> = ({
  network,
  iconOverride,
}) => {
  // Get fallback icon if network.name exists but network.icon doesn't or is empty
  const getFallbackIcon = () => {
    if (!network?.name) return null;

    // Only skip fallback if network.icon is a valid non-empty string
    if (
      network?.icon &&
      typeof network.icon === 'string' &&
      network.icon.trim() !== ''
    ) {
      return null;
    }

    // Try to find fallback icon by network name (case-insensitive)
    const fallbackIcon =
      networkFallbackIcons[network.name] ||
      networkFallbackIcons[network.name.toLowerCase()] ||
      networkFallbackIcons[
        network.name.charAt(0).toUpperCase() +
          network.name.slice(1).toLowerCase()
      ];

    return fallbackIcon;
  };

  const fallbackIcon = getFallbackIcon();

  return (
    <div className="bitte-p-2.5 bitte-bg-[#1a1a1a] bitte-rounded bitte-inline-flex bitte-items-center bitte-gap-2">
      <span className="bitte-h-[16px] bitte-w-[16px]">
        {typeof network?.icon === 'string' && network.icon.trim() !== '' ? (
          <img
            src={iconOverride || (network?.icon as string)}
            alt={network?.name}
            width={16}
            height={16}
            className="rounded-full"
          />
        ) : fallbackIcon ? (
          <img
            src={fallbackIcon}
            alt={network?.name}
            width={16}
            height={16}
            className="rounded-full"
          />
        ) : (
          <div className="bitte-h-4 bitte-w-4 bitte-bg-blue-500 bitte-rounded-full" />
        )}
      </span>
      <span className="bitte-text-white bitte-text-xs bitte-font-semibold">
        {network?.name}
      </span>
    </div>
  );
};

export default NetworkBadge;
